export default __webpack_public_path__ + "static/media/gallery09.6aa426fb.webp";